import Layout from './layout.vue'
export default Layout


// WEBPACK FOOTER //
// ./src/framework/layout/index.js